// extracted by css-extract-rspack-plugin
export default {"resizable":"DetailsView_resizable__Pe+vl","details":"DetailsView_details__N3IAq"};